export const environment = {
    URL_API: 'https://militarapihml.cearaprev.ce.gov.br',
    URL_SGPREV: 'https://webapps-staging.seplag.ce.gov.br',
    env: 'HML',
};
